import React from "react";
import logo from "./logo.png";
import telegramLogo from "./telegram.svg";
import mailLogo from "./email.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <a href="https://b2bslots.com/" target="_blank"> */}
        <img src={logo} className="App-logo" alt="logo" />
        {/* </a> */}
        <p>По вопросам интеграции игр, обращайтесь по контактам ниже</p>
        <a
          className="App-link"
          href="tg://resolve?domain=b2bslots"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={telegramLogo} className="logo-tg" alt="logoTg" />
          @b2bslots
        </a>
        <a
          className="App-link-mail"
          href="mailto:patrners@b2bslots.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={mailLogo} className="logo-ml" alt="logoMl" />
          patrners@b2bslots.com
        </a>
      </header>
    </div>
  );
}

export default App;
